export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[640px] mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-3">
          <div className="w-1 h-7 md:h-8 rounded-full bg-primary-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            联系我们
          </h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8">
          有料要爆？欢迎投稿至17吃瓜爆料团队
        </p>

        <div className="rounded-xl bg-background-100 border border-background-200/70 p-8 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <div className="font-medium text-sm text-foreground-800 mb-1">投稿邮箱</div>
              <div className="text-xs text-foreground-500">tips@17chigua.com</div>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-accent-100 flex items-center justify-center mb-3">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <div className="font-medium text-sm text-foreground-800 mb-1">微信客服</div>
              <div className="text-xs text-foreground-500">17chigua666</div>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto rounded-xl bg-secondary-100 flex items-center justify-center mb-3">
                <i className="ri-file-text-line text-xl text-secondary-600"></i>
              </div>
              <div className="font-medium text-sm text-foreground-800 mb-1">内容申诉</div>
              <div className="text-xs text-foreground-500">appeal@17chigua.com</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}